import React from 'react';
import VoucherPage from './VoucherPage';

const RenewalPage: React.FC = () => {
  return <VoucherPage category="renewal" />;
};

export default RenewalPage;
